/**
 * Customer-related models
 */

/**
 * Customer DTO (Response)
 */
export interface CustomerDto {
  id: string;
  /** Account type: PERSONAL, BUSINESS, BOAT_CLUB */
  customerType?: string;
  firstName: string;
  lastName: string;
  businessName?: string | null;
  email: string;
  emailSecondary?: string | null;
  phoneMobile?: string | null;
  phoneHome?: string | null;
  address?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactCell?: string | null;
  emergencyContactRelationship?: string | null;
  emergencyContactEmail?: string | null;
  emergencyContactAddress?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Create customer request
 */
export interface CreateCustomerRequest {
  /** Account type: PERSONAL, BUSINESS, BOAT_CLUB */
  customerType?: string;
  firstName: string;
  lastName: string;
  businessName?: string | null;
  email: string;
  emailSecondary?: string | null;
  phoneMobile?: string | null;
  phoneHome?: string | null;
  address?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactCell?: string | null;
  emergencyContactRelationship?: string | null;
  emergencyContactEmail?: string | null;
  emergencyContactAddress?: string | null;
  isActive?: boolean;
}

/**
 * Update customer request
 */
export interface UpdateCustomerRequest {
  /** Account type: PERSONAL, BUSINESS, BOAT_CLUB */
  customerType?: string;
  firstName: string;
  lastName: string;
  businessName?: string | null;
  email: string;
  emailSecondary?: string | null;
  phoneMobile?: string | null;
  phoneHome?: string | null;
  address?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactCell?: string | null;
  emergencyContactRelationship?: string | null;
  emergencyContactEmail?: string | null;
  emergencyContactAddress?: string | null;
  isActive?: boolean;
}
